// extracted by mini-css-extract-plugin
export default {"container":"CollaboratorV2__container___SqlYu"};